<template>
	<p v-if="type === ' btn'" class="menu-item">{{ text }}</p>
	<a v-else class="menu-item" :href="link" target="_blank">
		{{ text }}
	</a>
</template>

<script setup lang="ts">
defineProps({
	text: { type: String, required: true },
	link: { type: String, required: false },
	type: { type: String, default: 'link' }
})
</script>

<style lang="scss" scoped>
.menu-item {
	color: var(--link);
	width: 100%;
	display: flex;
	font: var(--font-body-small);
	justify-content: center;
	margin-bottom: 12px;
	cursor: pointer;
	transition: $transition-color;
	&:hover {
		color: var(--link-hover);
	}
	&:active {
		color: var(--link-hover);
	}
}
</style>
